import { getFunctions, httpsCallable } from "firebase/functions";
import { log } from "../../helper/helper";
import config from "../../config.json";
import { getApp } from "firebase/app";

export function getFailedStripeTransfer(cursorTransportId) {
    let data = {};
    if (cursorTransportId !== "") {
        data = {
            cursor_transport_id: cursorTransportId,
        };
    }
    log(data);
    const functions = getFunctions(getApp(), config.australiaSoutheast);
    const allFailed = httpsCallable(functions, config.adminShowAllFailedStripeTransfer);
    return allFailed(data);
}


export function stripeTransferForTansports(transportsId) {
    let data = {
        transports_id: transportsId,
    };
    log(data);
    const functions = getFunctions(getApp(), config.australiaSoutheast);
    const stripeTransfer = httpsCallable(functions, config.adminPayStripeTransferForTansports);
    return stripeTransfer(data);
}
